import styled from "styled-components";
import { Modal } from "components/Modal";

export const MisplacedBrokerModalContainer = styled(Modal)`
  .modal-dialog {
    max-width: 390px;
  }
  .modal-content {
    border-radius: 15px;
  }
  .logo-img {
    display: flex;
    justify-content: center;
    margin-top: 25px;
    .img {
      width: 136px;
      height: 130px;
    }
  }
  .heading-space {
    display: flex;
    justify-content: center;
    margin-top: 1em;
    .heading {
      font-style: normal;
      font-weight: 700;
      font-size: 23px;
      color: ${({ theme }) => theme.global.extraInfo.font.color};
      text-align: center;
    }
  }
  .btn-ok {
    text-align: center;
    margin-top: 30px;
    button {
      border-radius: ${({ theme }) => theme.constants.BORDER_RADIUS_8};
      padding: 8px 0;
    }
  }
`;
